import classnames from 'classnames/bind'

// Libs

// Components
import Link from '@/components/common/Link'

// Constants

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)
interface MenuItemProps {
  text: string
  url?: string
  icon?: React.ReactNode
  /** 有 url 時是否另開新分頁（預設是） */
  isOpen?: boolean
  handleClick: () => void
}

const MenuItem = ({ text, url, handleClick, icon, isOpen = true }: MenuItemProps) => {
  return (
    <li onClick={() => handleClick()}>
      {url ? (
        <Link className={cx('menu-item')} url={url} isOpen={isOpen}>
          <>
            {icon && <div className={cx('menu-item--icon')}>{icon}</div>}
            <h4>{text}</h4>
          </>
        </Link>
      ) : (
        <div className={cx('menu-item')}>
          {icon && <div className={cx('menu-item--icon')}>{icon}</div>}
          <p>{text}</p>
        </div>
      )}
    </li>
  )
}
export default MenuItem
